import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchesValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const password = control.parent?.get('password')?.value;
  const confirmPassword = control.parent?.get('confirmPassword')?.value;
  return password !== confirmPassword ? { passwordMismatch: true } : null;
};
